$(document).ready(function () {
	$('[data-toggle="input-counter"] .btn-minus, [data-toggle=input-counter] .btn-plus').click(function () {
		var $container = $(this).closest('[data-toggle="input-counter"]');
		var plus = $(this).hasClass('btn-plus');
		var $input = $container.find('input');
		var value = parseFloat($input.val());
		var step = parseFloat($input.attr('step'));
		var newValue;

		if (plus) {
			newValue = value + step;
		} else {
			newValue = value - step;
		}

		if (newValue > 0) {
			if (newValue % 1 !== 0) {
				newValue = +newValue.toFixed(2);
			}

			$input.val(newValue);
		}

		$input.trigger('change-counter');

		return false;
	});
});